
import { Options, Vue } from "vue-class-component";
import { Prop, Watch } from 'vue-property-decorator';
import QtsSemanalService from "@/service/v1/sigap/QtsSemanalService";

@Options({
    name: "QtsSemanalPdfView",
})
export default class QtsSemanalPdfView extends Vue {

    @Prop() readonly qtsSemanalId!: any

    public service = new QtsSemanalService();
    public tipo: 'pelotao' | 'horario' = 'pelotao';
    public pdfUrl = '';
    public carregando = false;
    public erro = '';

    created() {
        this.carregar();
    }

    @Watch('qtsSemanalId')
    public recarregar() {
        this.carregar();
    }

    public selecionar(tipo: 'pelotao' | 'horario') {
        if (this.tipo === tipo) return;
        this.tipo = tipo;
        this.carregar();
    }

    public carregar() {
        if (!this.qtsSemanalId) return;
        this.carregando = true;
        this.erro = '';
        const req = this.tipo === 'horario'
            ? this.service.getPdfPorHorarioBlob(this.qtsSemanalId)
            : this.service.getPdfBlob(this.qtsSemanalId);
        req
            .then((blob: Blob) => {
                this.liberarUrl();
                this.pdfUrl = URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
                this.carregando = false;
            })
            .catch(() => {
                this.carregando = false;
                this.erro = 'Não foi possível carregar o PDF.';
            });
    }

    private liberarUrl() {
        if (this.pdfUrl) {
            URL.revokeObjectURL(this.pdfUrl);
            this.pdfUrl = '';
        }
    }

    beforeUnmount() {
        this.liberarUrl();
    }
}
